import React from "react";
import { Play, Pause, SkipForward, SkipBack, X, Waveform, Shuffle } from "@phosphor-icons/react";
import { useWorshipRadio } from "../context/WorshipRadioContext";

// Floating mini-player for Worship Radio (real background audio). Shows
// whenever a station is loaded; persists across navigation so listening
// continues as you move around the app and with the screen off.
export default function WorshipRadioBar() {
  const { tracks, current, isPlaying, shuffle, toggle, next, prev, stop, toggleShuffle } = useWorshipRadio();
  if (!tracks.length || !current) return null;

  return (
    <div
      data-testid="worship-radio-bar"
      className="fixed left-4 z-[45] w-[min(440px,calc(100vw-2rem))] bottom-40 md:bottom-24"
    >
      <div className="glass rounded-2xl border border-terracotta/30 shadow-[0_-8px_32px_rgba(0,0,0,0.18)] pl-2 pr-3 py-2.5 flex items-center gap-2">
        {current.art ? (
          <img src={current.art} alt="" className="shrink-0 w-9 h-9 rounded-lg object-cover" data-testid="worship-art" />
        ) : (
          <span className="shrink-0 w-9 h-9 rounded-full bg-terracotta text-cream grid place-items-center">
            <Waveform size={16} weight="fill" />
          </span>
        )}
        <div className="flex items-center gap-0.5">
          <button onClick={prev} data-testid="worship-prev" className="w-8 h-8 grid place-items-center text-forest hover:text-terracotta transition-colors" aria-label="Previous">
            <SkipBack size={16} weight="fill" />
          </button>
          <button onClick={toggle} data-testid="worship-toggle" className="w-10 h-10 grid place-items-center text-forest hover:text-terracotta transition-all hover:scale-105 active:scale-95" aria-label={isPlaying ? "Pause" : "Play"}>
            {isPlaying ? <Pause size={20} weight="fill" /> : <Play size={20} weight="fill" />}
          </button>
          <button onClick={next} data-testid="worship-next" className="w-8 h-8 grid place-items-center text-forest hover:text-terracotta transition-colors" aria-label="Next">
            <SkipForward size={16} weight="fill" />
          </button>
          <button onClick={toggleShuffle} data-testid="worship-shuffle" className={`w-8 h-8 grid place-items-center transition-colors ${shuffle ? "text-terracotta" : "text-ink/45 hover:text-forest"}`} aria-label="Shuffle" title="Shuffle">
            <Shuffle size={15} weight="bold" />
          </button>
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] uppercase tracking-[0.16em] text-terracotta font-bold leading-none">Holy Words Radio{shuffle ? " · Shuffle" : ""}</div>
          <div className="text-forest font-semibold text-sm truncate leading-tight" data-testid="worship-title">{current.title}</div>
          {current.artist ? <div className="text-muted_ink text-xs truncate leading-tight">{current.artist}</div> : null}
        </div>
        <button onClick={stop} data-testid="worship-close" className="shrink-0 w-9 h-9 grid place-items-center text-ink/60 hover:text-ink transition-colors" aria-label="Close">
          <X size={16} weight="bold" />
        </button>
      </div>
    </div>
  );
}
